export const manageCubesQueryKeys = {
  all: ["manageCubes"] as const,
  cubeContext: (cubeId: string) =>
    [...manageCubesQueryKeys.all, "context", { cubeId }] as const,
  exports: (cubeId: string) =>
    [...manageCubesQueryKeys.all, "exports", { cubeId }] as const,
  exportPoll: (uid: string) =>
    [...manageCubesQueryKeys.all, "exportPoll", { uid }] as const
} as const;
